export const SET_FNA_VALUE = 'SET_FNA_VALUE'

export const setFnaValue = (fnaValue) => ({
  type: SET_FNA_VALUE,
  payload: fnaValue,
})

export const ENABLE_FNA_PHASE = 'ENABLE_FNA_PHASE'

export const enableFnaPhase = () => ({
  type: ENABLE_FNA_PHASE,
})

export const DISABLE_FNA_PHASE = 'DISABLE_FNA_PHASE'

export const disableFnaPhase = () => ({
  type: DISABLE_FNA_PHASE,
})

export const SET_FNA_VC_QUESTION = 'SET_FNA_VC_QUESTION'
export const setFnaVcQuestion = (value) => {
  return {
    type: SET_FNA_VC_QUESTION,
    payload: {
      value,
    },
  }
}

export const SET_FNA_SELLING_MODE = 'SET_FNA_SELLING_MODE'
export const setFnaSellingMode = (value) => {
  return {
    type: SET_FNA_SELLING_MODE,
    payload: {
      value,
    },
  }
}

export const SET_FNA_BUYWITHADVISOR = 'SET_FNA_BUYWITHADVISOR'
export const setFnaBuyWithAdvisor = (value) => {
  return {
    type: SET_FNA_BUYWITHADVISOR,
    payload: {
      value,
    },
  }
}

export const SET_FNA_ISSOCIAL = 'SET_FNA_ISSOCIAL'
export const setFnaIsSocial = (value) => {
  return {
    type: SET_FNA_ISSOCIAL,
    payload: {
      value,
    },
  }
}
